// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_ob-8";
export var editMode = "_ob-3";
export var headerRow = "_ob-a";
export var headerTitle = "_ob-b";
export var product = "_ob-1";
export var productDetails = "_ob-5";
export var productDivider = "_ob-7";
export var productImage = "_ob-2";
export var productInfo = "_ob-4";
export var productTitle = "_ob-6";
export var strikethrough = "_ob-9";
export var upsellProductsCard = "_ob-0";